/**
 * Created by Damian on 2017-11-03.
 */


export const constFonts = [
  {
    label: 'type of fonts',
    type: 'header',
    value : 'Roboto',
    disabled: false
  },
  {
    label: 'Roboto',
    value : 'Roboto',
    type: 'element',
  },
  {
    label: 'Open Sans',
    value: 'Open Sans',
    type: 'element'
  },
  {
    label: 'Josefin Slab',
    value: 'Josefin Slab',
    type: 'element'
  },
  {
    label: 'Arvo',
    value: 'Arvo',
    type: 'element'
  },
  {
    label: 'Lato',
    value: 'Lato',
    type: 'element'
  },
  {
    label: 'type of fonts 2',
    value : 'Vollkorn',
    type: 'header'
  },
  {
    label: 'Vollkorn',
    value: 'Vollkorn',
    type: 'element'
  },
  {
    label: 'Abril Fatface',
    value: 'Abril Fatface',
    type: 'element'
  },
  {
    label: 'Ubuntu',
    value: 'Ubuntu',
    type: 'element'
  },
  {
    label: 'PT Sans',
    value: 'PT Sans',
    type: 'element'
  },
  {
    label: 'PT Serif',
    value: 'PT Serif',
    type: 'element'
  },
  {
    label: 'Old Standard TT',
    value: 'Old Standard TT',
    type: 'element'
  },
  {
    label: 'Droid Sans',
    value: 'Droid Sans',
    type: 'element'
  },
  {
    label: 'Prociono',
    value: 'Prociono',
    type: 'element'
  }
]